module.exports = __webpack_public_path__ + "static/media/fly0110.725356be.webp";